import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../../data/content";

export default function Hero() {
  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src={IMAGES.heroBg} alt="" className="h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/70 to-obsidian/20" />
        <div className="absolute inset-y-0 left-0 w-1/2 bg-gradient-to-r from-obsidian to-transparent" />
      </div>

      <div className="absolute inset-0 z-0 max-w-7xl mx-auto px-6 lg:px-8 hidden md:flex justify-between">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="w-px h-full bg-white/[0.04]" />
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full pb-20 pt-32 md:pb-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="overline mb-6">Entrepreneur & Business Leader — Building Worldwide</div>
          <h1 className="font-display font-bold text-[2.25rem] sm:text-6xl md:text-8xl leading-[1] sm:leading-[0.95] md:leading-[0.92] tracking-tight max-w-4xl">
            Building Ventures
            <br />
            That <span className="text-amber">Matter.</span>
          </h1>
          <div className="mt-8 md:mt-10 flex flex-col md:flex-row md:items-end md:justify-between gap-6 md:gap-8">
            <p className="text-ink-secondary text-base md:text-lg max-w-xl leading-relaxed">
              Turning bold ideas into thriving businesses — from early concept to sustainable growth and lasting impact
              across global markets.
            </p>
            <a
              href="#portfolio"
              data-testid="hero-cta"
              className="group inline-flex items-center gap-3 rounded-full border border-white/15 px-7 py-4 text-sm font-semibold uppercase tracking-[0.12em] hover:border-amber hover:text-amber transition-colors duration-300 whitespace-nowrap self-start"
            >
              View Portfolio
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
